export default {
  namespaced: true,
  getters: {
    permisosGerentes(state, getters, rootState) {
      return (
        rootState.CARGO.id == 2 || // GERENTE GENERAL
        rootState.CARGO.id == 3 // GERENTE REGIONAL
      );
    },
  },
};
